import { gql, TypedDocumentNode } from '@apollo/client';
import { CART_FRAGMENT, Cart, CartVersion } from '../../hooks/useCart/cart.rest';

export type DeleteLineItemMutationVariables = {
  id: string;
  cartVersion: CartVersion;
  countryCode: string;
};

export type DeleteLineItemMutation = {
  deleteLineItem: {
    data: Cart[];
  };
};

export const DELETE_LINE_ITEM_MUTATION: TypedDocumentNode<
  DeleteLineItemMutation,
  DeleteLineItemMutationVariables
> = gql`
  mutation DeleteLineItemMutation($id: String!, $cartVersion: String!, $countryCode: String!) {
    deleteLineItem(id: $id, cartVersion: $cartVersion, countryCode: $countryCode)
      @rest(
        type: "RestDeleteLineItem"
        endpoint: "moda"
        path: "/v3.5/line_items/{args.id}?target={args.cartVersion}&country_code={args.countryCode}"
        method: "DELETE"
      ) {
      data @type(name: "RestUserCartData") {
        ...CartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;

export type LineItemType = 'CartItem' | 'SavedItem';

export type UpdateLineItemMutationInputAttributes = {
  sku_id: number;
  quantity: number;
  type: LineItemType;
  moved_automatically?: boolean | null;
};

export type UpdateLineItemMutationInput = {
  data: {
    type: 'line_items';
    id: string;
    attributes: UpdateLineItemMutationInputAttributes;
  };
};

export type UpdateLineItemMutationVariables = {
  id: string;
  cartVersion: CartVersion;
  input: UpdateLineItemMutationInput;
  countryCode: string;
};

export type UpdateLineItemMutation = {
  updateLineItem: {
    data: Cart[];
  };
};

export const UPDATE_LINE_ITEM_MUTATION: TypedDocumentNode<
  UpdateLineItemMutation,
  UpdateLineItemMutationVariables
> = gql`
  mutation UpdateLineItemMutation(
    $id: String!
    $cartVersion: String!
    $input: UpdateLineItemMutationInput!
    $countryCode: String!
  ) {
    updateLineItem(id: $id, cartVersion: $cartVersion, input: $input, countryCode: $countryCode)
      @rest(
        type: "RestUpdateLineItem"
        endpoint: "moda"
        path: "/v3.5/line_items/{args.id}?target={args.cartVersion}&country_code={args.countryCode}"
        method: "PATCH"
      ) {
      data @type(name: "RestUserCartData") {
        ...CartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;
